"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSIVRPinComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const ivrpin_service_1 = require("./../services/ivrpin.service");
const account_service_1 = require("./../services/account.service");
const generic_content_service_1 = require("../services/generic.content.service");
class CSIVRPinComponent {
    constructor(modalService, genericContentService, accountService, ivrpinservice) {
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.accountService = accountService;
        this.ivrpinservice = ivrpinservice;
    }
    open(content, options = { size: 'lg', windowClass: 'supend-info' }) {
        this.modelError = null;
        this.modelRef = this.modalService.open(content, options);
    }
    ngOnInit() {
        this.getErrorMessage();
    }
    createIvrPin(pin, actionType) {
        this.loading = true;
        this.ivrpinservice.createIvrPin(pin, actionType)
            .subscribe((data) => {
            this.loading = false;
            this.modelRef.close();
            this.open(this.sucessIvr);
        }, (err) => {
            this.modelError = err;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
}
exports.CSIVRPinComponent = CSIVRPinComponent;
//# sourceMappingURL=ivrpin.component.js.map